import React, { Component } from 'react';
import { Segment, Input, Button, Message } from 'semantic-ui-react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';

const inputStyle = {
  marginTop: 10,
  marginBottom: 10,
};

class CampaignGoogleLinkTracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.baseTrackingUrl,
      savedOK: false,
    };
  }

  onInputValueChanged = (event, { value }) => {
    this.setState({
      value,
    });
  }

  onSaveButtonClick = async () => {
    const { value } = this.state;
    const { campaignId, jsonAPIClient } = this.props;
    const response = await jsonAPIClient.get('campaigns', campaignId);
    response.set('baseTrackingUrl', value);
    await response.sync();
    this.setState({
      savedOK: true,
    });
  }

  render() {
    const { value, savedOK } = this.state;
    const shouldDisableSubmitButton = _.isEmpty(_.trim(value));
    const isValidURL = _.startsWith(value, 'https://') || _.startsWith(value, 'http://');
    return (
      <Segment>
        <h3>Google Analytics</h3>
        <p>
            Set up your google link tracking here.
            Enter the base URL for your campaign and dyzio will generate all your tracking links for you.
        </p>
        <Input
          value={value}
          onChange={this.onInputValueChanged}
          style={inputStyle}
          fluid
          placeholder="Enter your tracking base URL for the campaign."
        />
        <small>e.g. https://dyzio.co/pricing</small>
        <Button
          disabled={shouldDisableSubmitButton || !isValidURL}
          style={inputStyle}
          color="pink"
          icon="google"
          value={value}
          fluid
          labelPosition="left"
          content="Authorise Google Analytics"
          onClick={this.onSaveButtonClick}
        />
        {
          savedOK && <Message positive>Saved</Message>
        }
      </Segment>
    );
  }
}

export default compose(
  hasJSONAPIClient,
)(CampaignGoogleLinkTracking);



/** WEBPACK FOOTER **
 ** ./src/components/campaign-google-link-tracking/index.js
 **/